import type { LucideIcon } from "lucide-react";
import {
  StoreIcon,
  UtensilsIcon,
  CarIcon,
  HardHatIcon,
  UserRoundIcon,
  ShoppingBagIcon,
  ImagesIcon,
  MousePointerClickIcon,
  MapPinIcon,
  BadgeCheckIcon,
  RefreshCwIcon,
  TrendingUpIcon,
  PenLineIcon,
  ServerIcon,
  ShieldCheckIcon,
  BarChart3Icon,
  PlugIcon,
} from "lucide-react";

export type NavService = { label: string; href: string; blurb: string; icon: LucideIcon };
export type NavGroup = { title: "Websites" | "Growth" | "Ongoing"; items: NavService[] };

export const SERVICE_GROUPS: NavGroup[] = [
  {
    title: "Websites",
    items: [
      { label: "Small Business", href: "/services/small-business", blurb: "A professional site that wins local trust.", icon: StoreIcon },
      { label: "Restaurant", href: "/services/restaurant", blurb: "Menus, hours, reservations and delivery links.", icon: UtensilsIcon },
      { label: "Automotive", href: "/services/automotive", blurb: "Service lists, online booking, trust badges.", icon: CarIcon },
      { label: "Contractor & Service Provider", href: "/services/contractors", blurb: "Project galleries, service areas, estimates.", icon: HardHatIcon },
      { label: "Personal Brand", href: "/services/personal-brand", blurb: "A home for your name, story and offers.", icon: UserRoundIcon },
      { label: "E-commerce", href: "/services/ecommerce", blurb: "Products, cart and secure checkout.", icon: ShoppingBagIcon },
      { label: "Portfolio", href: "/services/portfolio", blurb: "Show your work the way it deserves.", icon: ImagesIcon },
      { label: "Landing Pages", href: "/services/landing-pages", blurb: "Single-goal pages built to convert.", icon: MousePointerClickIcon },
    ],
  },
  {
    title: "Growth",
    items: [
      { label: "Local SEO", href: "/services/local-seo", blurb: "Get found by customers near you.", icon: MapPinIcon },
      { label: "Google Business Profile Setup", href: "/services/local-seo#google-business-profile", blurb: "Claim, verify and complete your profile.", icon: BadgeCheckIcon },
      { label: "Website Redesign", href: "/services/redesign", blurb: "Rebuild an outdated site, keep what works.", icon: RefreshCwIcon },
      { label: "Conversion Optimization", href: "/services/redesign#conversion-optimization", blurb: "Turn more visitors into calls and leads.", icon: TrendingUpIcon },
      { label: "Copywriting & Content", href: "/services/redesign#copywriting", blurb: "Clear words that explain what you do.", icon: PenLineIcon },
    ],
  },
  {
    title: "Ongoing",
    items: [
      { label: "Hosting & Maintenance", href: "/services/hosting-maintenance", blurb: "Secure hosting, updates and support.", icon: ServerIcon },
      { label: "Website Care Plans", href: "/services/hosting-maintenance#care-plans", blurb: "Ongoing edits and upkeep, handled.", icon: ShieldCheckIcon },
      { label: "Analytics & Reporting", href: "/services/hosting-maintenance#analytics", blurb: "Know where your visitors come from.", icon: BarChart3Icon },
      { label: "Integrations & Automations", href: "/services/hosting-maintenance#integrations", blurb: "Connect booking, CRM and email tools.", icon: PlugIcon },
    ],
  },
];

export const RESOURCE_LINKS = [
  { label: "Blog", href: "/resources", blurb: "Guides for owners building online." },
  { label: "FAQ", href: "/resources/faq", blurb: "Every question, searchable." },
  { label: "Website Checklist", href: "/resources/website-checklist", blurb: "Free download before you build." },
  { label: "Live Demo", href: "/demo", blurb: "Preview a NEXORA build on any device." },
];

export const PRIMARY_NAV = [
  { label: "Work", href: "/work" },
  { label: "Pricing", href: "/pricing" },
  { label: "Process", href: "/process" },
  { label: "About", href: "/about" },
];

export const FOOTER_STUDIO = [
  { label: "Services", href: "/services" },
  { label: "Work", href: "/work" },
  { label: "Pricing", href: "/pricing" },
  { label: "Process", href: "/process" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" },
];

export const FOOTER_CLIENTS = [
  { label: "Client Login", href: "/client-login" },
  { label: "Client Dashboard", href: "/client-dashboard" },
  { label: "Register", href: "/register" },
  { label: "Live Demo", href: "/demo" },
];

export const FOOTER_LEGAL = [
  { label: "Privacy Policy", href: "/privacy" },
  { label: "Terms of Service", href: "/terms" },
  { label: "Cancellation Policy", href: "/cancellation-policy" },
  { label: "Sitemap", href: "/sitemap" },
];
